module.exports = {
  WarehouseNo: 'WarehouseNo',
  Warehouse: 'Warehouse',
  WarehouseInDate: 'WarehouseInDate',
  State: 'State',
  PackageWarehouseInDate: 'PackageWarehouseInDate',
  PackageWarehouseOutDate: 'PackageWarehouseOutDate',
  ReceiptNumber: 'ReceiptNumber',
  ReceiptNo: 'ReceiptNo',
  PortOfDestination: 'PortOfDestination',
  StorageDate: 'StorageDate',
  DeliveryDate: 'DeliveryDate',
  StorageDay: 'StorageDay',
  ActStorageDay: 'Actual storage date',
  DeliveryDay: 'DeliveryDay',
  ActDeliveryDay: 'Actual delivery date',
  InputTime: 'InputTime',
  DataEntryClerk: 'DataEntryClerk',
  NumberOfCases: 'NumberOfCases',
  Weight: 'Weight',
  Volume: 'Volume',
  ComputationIsAffectedByDampness: 'ComputationIsAffectedByDampness',
  IsNotComputationIsAffectedByDampness: 'IsNotComputationIsAffectedByDampness',
  ComputationIsAffectedByDampnessNum: 'ComputationIsAffectedByDampnessNum',
  IntoTheWarehousePhotos: 'IntoTheWarehousePhotos',
  WarehouseName: 'WarehouseName',
  DeliveryMode: 'DeliveryMode',
  Warehouseman: 'Warehouseman',
  WarehouseLocation: 'WarehouseLocation',
  StorageLocation: 'StorageLocation',
  TemperatureRequirement: 'Temperature Requirement',
  DeliveryCmp: 'DeliveryCmp',
  IssueOrNot: 'IssueOrNot',
  PalletSum: 'Pallet Sum',
  ReceiveDc: 'ReceiveDc',
  LicensePlate: 'LicensePlate',
  DescriptionOfGoods: 'DescriptionOfGoods',
  HandlingOpinions: 'HandlingOpinions',
  Remark: 'Remark',
  SealingWeight: 'SealingWeight',
  Driver: 'Driver',
  DriverPhone: 'DriverPhone',
  IsTheGoodsClosed: 'IsTheGoodsClosed',
  WarehouseInformation: 'WarehouseInformation',
  CargoDetails: 'CargoDetails',
  CargoPhotos: 'CargoPhotos',
  OperationRequirements: 'OperationRequirements',
  SelectFile: 'SelectFile',
  DeleteFile: 'DeleteFile',
  AddCargo: 'AddCargo',
  Detail: 'Detail',
  Summary: 'Summary',
  FillData: 'Fill',
  maintenanceAllType: 'Container No. & Weight Dimensions',
  maintenanceContainerNoType: 'Container number only',
  maintenanceWeightAndSizeType: 'Weight and size only',
  DeleteCargo: 'DeleteCargo',
  JobNumberInformation: 'JobNumberInformation',
  Statistics: 'Statistics',
  Number: 'Number',
  QuantityActual: 'QuantityActual',
  WeightActual: 'WeightActual',
  CubageActual: 'CubageActual',
  WarehouseOutState: 'Out-warehouse state',
  WarehouseInState: 'In-warehouse state',
  WarehouseIn: 'Be put in storage',
  WarehouseOut: 'Go out of the warehouse',
  NewWarehouseFee: 'New Warehouse Fee',
  WarehousePhotos: 'Warehouse Photos',
  StorageDayCanNotBeNull: 'Storage day can not be null.',
  DeliveryDayCanNotBeNull: 'Delivery day can not be null.',
  WarehouseInSuccess: 'It\'s successfully entered the library.',
  WarehouseOutSuccess: 'Have successfully released the library',
  NoChoiceWarehouseToBePrinted: 'No choice is given for the warehouse information to be printed!',
  PleaseSelectTheWarehousingNoticeToBeDeleted: 'Please select the warehousing notice to be deleted',
  WarehousingNotice: 'Warehousing notice',
  AreYouSureToDeleteThisWarehousingNotice: 'Are you sure to delete this warehousing notice',
  DeleteWarehousingNotice: 'Delete warehousing notice',
  ImportingData: 'Importing data',
  ThisOperationIsAnAsynchronousImport: 'This operation is an asynchronous import. You can view the import results in file storage - > upload log',
  ViewResults: 'View results',
  BatchImportWarehousing: 'Batch import warehousing',
  BatchImportWarehousingData: 'Batch import warehousing data',
  NoWarehouseReceiptSelected: 'No warehouse receipt selected',
  Checklist: 'Checklist',
  ReturnGoods: 'return goods',
  OnlySave: 'only Save',
  Save: 'Save',
  SaveAndWeigh: 'Save and weigh',
  SaveAndChecklist: 'Save and check the list',
  WeighAndChecklist: 'Weigh and check the list',
  PoOriginalOrderNo: 'Po (original order No.)',
  ServiceChannel: 'Service channel',
  DestinationDeliveryMethod: 'Destination delivery method',
  OverseasWarehouse: 'Overseas warehouse',
  DestinationCountry: 'Destination country',
  Weigh: 'Weigh',
  ReceivingWarehouse: 'Receiving warehouse',
  CommissionNo: 'Commission No',
  OverseasWarehouseCode: 'Overseas warehouse code',
  RemoteWarehouse: 'Remote warehouse',
  boxLengthPlaceholder: 'Length',
  boxWidthPlaceholder: 'Width',
  BoxHeightPlaceholder: 'Height',
  SizeNotZero: 'Length, width, height, and piece count cannot be less than or equal to 0',
  EstEnteringAmazonWarehouse: 'Expected time of entering Amazon warehouse',
  ChargingMethod: 'Charging Method',
  Total: 'Total',
  WeighTime: 'Weigh Time',
  ChecklistTime: 'Checklist Time',
  ReturnGoodsTime: 'Return Goods Time',
  CourierServicesCompany: 'Courier Services Company',
  Electric: 'Is it electrified',
  Magnetic: 'Magnetic',
  Powdery: 'Powder',
  Liquid: 'Liquid',
  BatchMaintenance: 'Batch maintenance',
  PickingGoods: 'Picking by customer data',
  AdjustChargeWeight: 'Adjust billing weight',
  ContainerNo: 'Container number',
  BoxesNumber: 'Number of boxes',
  SingleBoxWeight: 'Single container weight (kg)',
  DialogSingleBoxWeight: 'Single container weight (kg)',
  BoxLength: 'Container length (CM)',
  BoxWidth: 'Container width (CM)',
  BoxHeight: 'Container height (CM)',
  UnitRate: 'Declared unit price (single product)',
  Quantity: 'Declared quantity (single box)',
  BoxSize: 'Single box size',
  HsCode: 'Customs Code',
  Brand: 'Brand',
  BrandType: 'Brand type',
  ModelNo: 'model',
  MaterialQuality: 'texture of material',
  Purpose: 'purpose',
  SalesLink: 'Sales link',
  SalesPrice: 'selling price',
  PictureUrl: 'picture',
  WeightKg: 'Weight (kg)',
  CargoType: 'Type of goods',
  ProductDescription: 'Product description',
  CheckWeighTime: 'This warehousing information has been weighed. Do you want to update the weighing data?',
  ChecklistTimeTip: 'The verification time[{0}] cannot be less than the weighing time[{1}], please check',
  ReturnReason: 'Reason for return',
  ReturnGoodsTips: 'It contains the {0} data. Please confirm whether to return the parts?',
  ChecklistResult: 'Checklist Result',
  ModifiedReason: 'Reason for order change',
  WsTjRemark: 'Order modification instructions',
  WsTjReason: 'Reason for deleting order',
  WsTjDelRemark: 'Order deleting instructions',
  ModifiedWsTjTips: 'Additional explanation is required for other reasons',
  FaceOrderPrintTime: 'Printing time of express sheet',
  CourierNumber: 'courier number',
  RefContainerNo: 'Reference case No',
  isWeigh: 'Is Weigh',
  isChecklist: 'Is Checklist',
  isReturn: 'Is Return',
  ChecklistTip: 'The selected data contains unweighted data, please check.',
  alreadyChecklist: 'The job already checklist, please check.',
  delChecklistData: 'The selected data contains the checklist data, can not delete.',
  repeatPackingData: 'The selected data contains the packing data, can not packing repeated, please check.',
  cannotEditOutData: 'Data that has been shipped out cannot be edited',
  ChecklistTipOne: 'The selected data contains unweighted data. Is it approved?',
  RegistrationSlip: 'Registration slip',
  ContainerNoEditor: 'Editor Box Number',
  PreContainerNo: 'Container No Prefix(FBA No):',
  boxNum: 'Box Number:',
  boxSeq: 'Box Sequence:',
  boxSeqType3: '3 long in length',
  boxSeqType6: '6 long in length',
  boxSeqTooLong: 'Box serial number exceeds maximum[{0}],Please check',
  duplicateContainerNo: 'Container No[{0}] already exists, please fill in again',
  shipmentIdNotNull: 'Please maintain the shipment Id first!',
  boxesNumberNotNull: 'Please maintain the number of boxes first!',
  cargoChineseNameNotNull: 'Please maintain the cargo chinese name first!',
  cargoEnglishNameNotNull: 'Please maintain the cargo english name first!',
  singleBoxWeightNotNull: 'Please maintain the single box weight first!',
  boxesSizeNotNull: 'Please maintain single box size first!',
  boxSeqNotNull: 'Please maintain the serial number of the box first',
  deleteTheDetailRecord: 'All details in the current list will be cleared,Continue?',
  overwriteTheDetailRecord: 'All details in the current list will be overwritten as customer data. Continue?',
  overwriteTheDetailRecordByJobRelated: 'The business already has container cargo information, and will find the actual container cargo data in the domestic information warehouse. Do you want to continue?',
  continuePicking: 'Hot core list, do you want to continue packing?',
  continueReturnGoods: 'Consolidation and other operations will not be processed after the item is returned. Do you want to continue?',
  editShipmentId: 'The container number does not match the Shipment Id, Do you want to refresh the container number?',
  editActJmt: 'The box details already have value, it is not allowed to modify the summary weight information!',
  Packing: 'Packing',
  storageAgeEdit: 'Storage Age Adjustment',
  storageAgeEditDay: 'Days (automatically calculated/actual)',
  storageAgeEditWeek: 'Week (automatic calculation/actual)',
  ExWarehouse: 'Ex warehouse',
  weightOpCannotChecklist: 'It is not allowed to save. If you want to check the order, please click the [Weigh and Check] button to operate.',
  saveCheckContainerNoFail: 'The detailed data does not maintain the container number, please check! ',
  saveCheckShipmentIdFail: 'The Shipment Id is not maintained in the detailed data, please check! ',
  saveCheckQuantityFail: 'The weight of a single cargo box is not maintained in the detailed data, please check! ',
  saveCheckBoxLengthFail: 'Detailed data does not maintain the length of the box, please check! ',
  saveCheckBoxWidthFail: 'Detailed data does not maintain the width of the box, please check! ',
  saveCheckBoxHeightFail: 'Detailed data does not maintain the height of the cargo box, please check! ',
  saveCheckChineseCargoNameFail: 'The Chinese Cargo Name is not maintained in the detailed data, please check! ',
  saveCheckEnglishCargoNameFail: 'Detailed existing data does not maintain English product name, please check! ',
  saveCheckBrandFail: 'The data exists in the details and the brand is not maintained, please check! ',
  saveCheckBrandTypeFail: 'The brand type is not maintained in the detailed data, please check! ',
  FaceListCheckExpressDelivery: 'The delivery method of the destination is not express delivery, and there is no need to register a face-to-face list',
  FaceListCheckTip: 'There is no weighing information. Do you want to continue to register the express manifest information?',
  PackingTipOne: 'It contains returned part data and cannot be packed. Please check.',
  PackingTipTwo: 'The selected data contains data that failed to pass the verification. Do you want to continue packing?',
  ExWarehouseTip: 'The selected data contains issued data, please check',
  LabelingTime: 'Labeling time',
  Labeling: 'Labeling',
  Pallet: 'Whether to play a prop',
  PalletNo: 'Pallet No',
  DaycareInformation: 'Daycare information',
  PreDeliveryTime: 'PreDeliveryTime',
  ActDeliveryTime: 'ActDeliveryTime',
  LogisticsNo: 'Logistics order No',
  OperationStatus: 'OperationStatus',
  LogisticsNoEnd: 'LogisticsNoEnd',
  palletContainerNum: 'Pallet Container Number',
  otherContainerNum: 'Other Container Number',
  updateIssueRemarks: 'Issue remarks',
  DateOfService: 'Date of service',
  onWarehouseInCheck: 'The selected data contains data other than those to be received. Please check',
  PleaseChooseADataEntry: 'Please choose a data entry!',
  ExternallyImportedDataCannotEdit: 'Externally imported data, cannot edit.',
  CannotEditExternalData: 'Cannot edit external data.',
  PleaseChooseDesignatedData: 'Please choose designated data',
  CargoWareDoorstepVehicleDrivingButton: 'CargoWare-business function-customers\' doorstep-vehicle driving trajectory (click button)',
  PlateOrderNumberCannotEmpty: 'Plate number and order number cannot be empty',
  NoAvailableAtThisTime: 'No related information available at this time'
}
